import axiosClient from '../axiosClient';
import { Epic } from '../../types/common';

export const epicsApi = {
  // Get all epics for a board (AGE-11 & AGE-13 rollup)
  getEpics: async (boardId: string): Promise<Epic[]> => {
    const response = await axiosClient.get(`/boards/${boardId}/epics`);
    return Array.isArray(response.data) ? response.data : response.data.data || [];
  },

  // Get single epic
  getEpic: async (epicId: string): Promise<Epic> => {
    const response = await axiosClient.get(`/epics/${epicId}`);
    return response.data.data || response.data;
  },

  // Create epic
  createEpic: async (data: Partial<Epic>): Promise<Epic> => {
    const payload = {
      name: data.name,
      description: data.description,
      boardId: Number(data.boardId) || 1,
    };
    const response = await axiosClient.post('/epics', payload);
    return response.data.data || response.data;
  },

  // Update epic
  updateEpic: async (epicId: string, data: Partial<Epic>): Promise<Epic> => {
    const payload = {
      name: data.name,
      description: data.description,
    };
    const response = await axiosClient.patch(`/epics/${epicId}`, payload);
    return response.data.data || response.data;
  },

  // Delete epic
  deleteEpic: async (epicId: string): Promise<void> => {
    await axiosClient.delete(`/epics/${epicId}`);
  },

  // Get tasks in an epic
  getEpicTasks: async (epicId: string): Promise<any[]> => {
    const response = await axiosClient.get(`/tasks/epic/${epicId}`);
    return Array.isArray(response.data) ? response.data : response.data.data || [];
  },
};
